module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/emily-rivera-b69b5c6c8a785826b7d2db51d6ff5cff.jpg";